import React from "react";
import imagesMap from "../../../../assets/data/imagesMap"

const SceneZoomButton = props => {
  const { active, onZoom } = props;
  if (active) {
    return (
      <img
        onClick={() => onZoom("collapse")}
        className="zoom-button"
        src={imagesMap['collapse']}
      />
    );
  } else {
    return (
      <img
        onClick={() => onZoom("expand")}
        className="zoom-button"
        src={imagesMap['expand']}
      />
    );
  }
};

export default SceneZoomButton;
